import dayjs from 'dayjs';

import { DONATION_ROUTES } from '@/constants';

import type { ParticipationStatus } from './resolveRouletteCta';
import { resolveRouletteCta } from './resolveRouletteCta';

//* 기부 내역 API가 지자체 ID를 주지 않아 이름 키워드로 판정한다(LocalEventSection과 같은 방식).
const NONSAN_KEYWORD = '논산';

export type NonsanRouletteEntry =
  | { kind: 'hidden' }
  | { kind: 'loading' }
  | { kind: 'link'; href: string }
  | { kind: 'disabled'; label: string };

interface ResolveNonsanRouletteEntryParams {
  institutionName: string;
  paidAt: string;
  epayNumber: string;
  config?: { startAt: string; endAt: string; soldOutYN: boolean };
  status?: { participationStatus: ParticipationStatus; myResult?: unknown };
  isStatusLoading: boolean;
  isConfigLoading: boolean;
}

export const resolveNonsanRouletteEntry = ({
  institutionName,
  paidAt,
  epayNumber,
  config,
  status,
  isStatusLoading,
  isConfigLoading,
}: ResolveNonsanRouletteEntryParams): NonsanRouletteEntry => {
  if (!institutionName.includes(NONSAN_KEYWORD)) {
    return { kind: 'hidden' };
  }

  //* 응답 전에 hidden으로 두면 소비자가 다른 버튼을 먼저 그리고 나중에 바꾼다 — 거짓 UI.
  if (isConfigLoading || isStatusLoading) {
    return { kind: 'loading' };
  }

  if (!config) {
    return { kind: 'hidden' };
  }

  const paidDay = dayjs(paidAt);
  if (paidDay.isBefore(config.startAt) || paidDay.isAfter(config.endAt)) {
    return { kind: 'hidden' };
  }

  if (
    status?.myResult ||
    status?.participationStatus === 'ALREADY_PARTICIPATED'
  ) {
    return { kind: 'hidden' };
  }

  const cta = resolveRouletteCta({
    hasSettledResult: false,
    participationStatus: status?.participationStatus,
    isSoldOut: config.soldOutYN || status?.participationStatus === 'SOLD_OUT',
    startAt: config.startAt,
  });

  if (cta.kind === 'spin') {
    return {
      kind: 'link',
      href: DONATION_ROUTES.NONSAN_ROULETTE.withSearchParams({
        searchParams: { epayNo: epayNumber },
      }),
    };
  }

  if (cta.kind === 'disabled') {
    return { kind: 'disabled', label: cta.label };
  }

  return { kind: 'hidden' };
};
